import React from "react";
import cx from "classnames";
import Link from "../../Link";

const SubMenuItem = ({
  title,
  description,
  imageSrc,
  linkTo = "#",
  isInProgress = false,
  disabled = false,
}) => {
  return (
    <Link
      className={cx("sub-menu-item d-flex my-1 p-3 w-100", {
        disabled: disabled,
      })}
      to={linkTo}
    >
      {imageSrc && (
        <div className="sub-menu-item__image mt-1 mr-3">
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
            width={45}
            height={45}
          />
        </div>
      )}
      <div className="sub-menu-item__content d-flex flex-column align-self-center">
        <div className="d-flex align-items-center mb-2">
          <h6 className="sub-menu-item__content-title mb-0">{title}</h6>{" "}
          {isInProgress && (
            <div className="badge ml-2 py-1 px-2">COMING SOON</div>
          )}{" "}
        </div>
        {description && <span className="description">{description}</span>}
      </div>
    </Link>
  );
};

export default SubMenuItem;
